<script>
// Extensions
import View from "@/views/View";

// Mixins
import LoadSections from "@/mixins/load-sections";

export default {
  name: "Article",

  metaInfo: { title: "Blog Article" },

  extends: View,

  mixins: [
    LoadSections([
      "hero-alt",
      "article",
      // 'social-media',
      // "news",
      // "back-to-blog-overview",
      // 'newsletter-alt',
      // 'info',
      "info-alt"
    ])
  ],

  props: {
    id: {
      type: String,
      default: "article"
    }
  }
};
</script>
